// src/hr.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Hr = React.forwardRef(
  ({ style, ...props }, forwardedRef) => /* @__PURE__ */ jsx(
    "hr",
    {
      ...props,
      ref: forwardedRef,
      "data-id": "react-email-hr",
      style: {
        width: "100%",
        border: "none",
        borderTop: "1px solid #eaeaea",
        ...style
      }
    }
  )
);
Hr.displayName = "Hr";
export {
  Hr
};
